// extracted by mini-css-extract-plugin
module.exports = {"trainBlock":"Train_trainBlock__3UPDp","grade":"Train_grade__1tskH","active":"Train_active__1mjl0"};